import { Provider } from "react-redux";
import DefaultScreen from "./screens/DefaultScreen";
import StoreManager from "./redux/index";
import React, { Suspense } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import BackgroundTaskService from "./services/BackgroundTaskService";
import AppConfig from "./config/AppConfig";

import "./App.css";

class App extends React.Component {
    constructor(props) {
        super(props);
        
        // 修改原因： 阿里云短信内容中不能填写二级域名，只能填写一级域名
        // 方案： 先跳转到一级域名，再由一级域名重定向到二级域名
        // 1. 通过邀请用户注册推广短信中的激活链接跳转到Web站点(一级域名)
        // 2. 重定向到API站点(二级域名)
        // 例如：https://www.yofrive.com/[8位激活码] =》 https://api.yofrive.com/[8位激活码]
        const pathname = window.location.pathname;
        const match = pathname.match(/^\/([a-zA-Z0-9]{8})\/?$/);
        if (match) {
            const code = match[1];
            window.location.replace(`${AppConfig.APP_SERVICE_BASE}/${code}`);
        }
    }

    componentDidMount() {
        // create store when app starts
        //BackgroundTaskService.startProcessing();
    }

    componentWillUnmount() {
        // create store when app starts
        //BackgroundTaskService.stopProcessing();
    }

    render() {
        return (
            <Provider store={StoreManager.getStore()}>
                <Router>
                    <Suspense fallback={<div className="loader"></div>}>
                        <Route path="/" component={DefaultScreen} />
                    </Suspense>
                </Router>
            </Provider>
        );
    }
}

export default App;
